import { For, type Component } from 'solid-js';

/** How many motes drift up the title screen. */
const EMBER_COUNT = 28;

/**
 * One ember's drift, derived from its index.
 *
 * Deterministic on purpose: `Math.random()` would make the title screen a
 * different picture on every reload and every test run. A pair of irrational
 * multipliers scatters the values well enough that no pattern is visible.
 */
export function emberStyle(i: number): Record<string, string> {
  const golden = 0.6180339887;
  const spread = (i * golden) % 1;
  const jitter = (i * 0.7548776662) % 1;

  return {
    '--x': `${(spread * 100).toFixed(2)}%`,
    '--size': `${(2 + jitter * 4).toFixed(2)}px`,
    '--duration': `${(9 + jitter * 12).toFixed(2)}s`,
    '--delay': `${(spread * -18).toFixed(2)}s`,
    '--drift': `${((jitter - 0.5) * 160).toFixed(1)}px`,
    '--peak': (0.25 + jitter * 0.55).toFixed(2),
  };
}

/**
 * Embers rising off the bottom of the frame.
 *
 * Pure decoration: no state, no pointer events, and the whole thing collapses
 * to nothing under `prefers-reduced-motion` (see base.css).
 */
export const EmberField: Component = () => (
  <div class="embers" aria-hidden="true" data-testid="ember-field">
    <For each={Array.from({ length: EMBER_COUNT }, (_, i) => i)}>
      {(i) => <span class="ember" style={emberStyle(i)} />}
    </For>
  </div>
);
